import React from 'react';
import css from './create-tag-dropdown.module.scss';
import CreateTagIcon from '../../../image/create-tag.svg';
import {
	CreateFirstTagPopup,
} from '../../../widgets/templates/private-template-tag-group-panel/ui/dropdown/create-first-tag';
import { useCreateTagModal } from '../../../hooks/useCreateTagModal';
import { TagGroupType } from '../../../entities/template/private-template-tag-group/model/types';

interface CreateTagWithDropdownProps {
	groupId: string,
	onCreateTag: (name: string) => Promise<any>,
	bindTag: (data: { groupId: string; tags: number[] }) => Promise<any>,
	modalRef?: React.RefObject<HTMLDivElement>,
}

/**
 * Компонент для добавления тега. Включает в себя модальное окно для ввода названия.
 * @param modalRef - ref на контейнер. Нужен для расчета позиции модального окна создания тега (когда в крайнем правом
 * положении выходит за границу контейнера).
 */
export const CreateTagDropdown = ({
	groupId,
	onCreateTag,
	bindTag,
	modalRef,
}: CreateTagWithDropdownProps) => {
	const {
		isCreateModalOpen,
		createModalRef,
		closeModal,
		handleCreateTagAction,
		handleModalClick,
	} = useCreateTagModal(groupId);

	const bindCreatedTag = async (name: string) => {
		const res = await onCreateTag(name);
		if (res && groupId && groupId !== TagGroupType.tagsWithoutGroup) {
			await bindTag({ groupId, tags: [res.id] });
		}
	};

	return (
		<>
			<div
				className={css.create_tag_icon}
				key={-1}
				onClick={handleCreateTagAction}
				onKeyDown={handleCreateTagAction}
				tabIndex={0}
				role="button"
			>
				<CreateTagIcon />
			</div>
			{isCreateModalOpen && (
				<div
					ref={createModalRef}
					onClick={handleModalClick}
					onKeyDown={handleCreateTagAction}
					tabIndex={0}
					role="button"
				>
					<CreateFirstTagPopup
						groupId={groupId}
						onClose={closeModal}
						ref={createModalRef}
						bindCreatedTag={bindCreatedTag}
						modalRef={modalRef}
						isNeedUpdatePos
					/>
				</div>
			)}
		</>
	);
};
